/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react-hooks/exhaustive-deps */
import _ from 'lodash';
import * as L from 'leaflet';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import React, { useEffect, useState, createRef, useMemo } from 'react';
import { Checkbox, Space, Radio, Select, Input, } from 'antd';
import { useMapHelper, } from './helper';
import { filterSelectOptions, filterString } from 'datastake-daf/src/helpers/Forms';
import { dateFormat, filterValidGPS, getDateRanges, mapFiltersConfig } from './config';
import { findCoordinatesByCountry } from '../../../../../../../helpers/map';
import {
  defaultMapConfig,
  SET_VIEW_DEFAULT_ZOOM,
  defaultFilters,
  useMapConfig,
} from '../../../../../../../components/SubjectsMap/helper';

export const useMap = ({
  t = (t) => t,
  data: allData = null,
  user = null,
  language,
  onFiltersChange = () => { },
  module = 'pme',
  initialType = '',
  activeMapType = '',
  options,
  setActiveMapType = () => { },
  polygon,
}) => {
  const container = createRef();
  const { i18n } = useTranslation();
  const [data, setData] = useState([]);
  const [mapRef, setMapRef] = useState(null);
  const { TILE_LAYER_URL, MAP_TOKEN } = useMapConfig();
  const [initialMarkerSetIsDone, setInitialMarkerSetIsDone] = useState(false)
  const [mapCenter, setMapCenter] = useState([0, 0]);
  const [filtersOpen, setFiltersOpen] = useState(false);
  const [filters, setFilters] = useState(defaultFilters);
  const [emptyStateIsVisible, setEmptyStateIsVisible] = useState(false);
  const [initialRecenterDone, setInitialRecenterDone] = useState(false);
  const [initLoaded, setInitLoaded] = useState(false);
  const [polygonLayer, setPolygonLayer] = useState();

  const {
    addIconToMapInitialy,
    activeMarker,
    mapOptionsButtonsConfig,
    mapMarkers,
    clearMapMarkers,
    getZoom,
  } = useMapHelper({ mapRef, allData, mapCenter });

  const addAllDataToMap = () => {
    clearMapMarkers();
    if (data) {
      if (activeMapType === 'event') {
        const max = Math.max(...data.map((d) => d?.data?.length || 0));

        data.forEach((d) => {
          addIconToMapInitialy(
            [d.marker.lat, d.marker.lng],
            activeMapType,
            activeMapType === 'event' ? 'incident' : activeMapType,
            d,
            max,
          );
        });
      } else {
        data.forEach((d) => {
          addIconToMapInitialy(
            [d.marker.lat, d.marker.lng],
            'location',
            d.category || 'mineSite',
            d,
          );
        });
      }
    }
  };

  const createInstance = () => {
    var c = L.DomUtil.get(document.getElementById(container.current));
    if (c != null) {
      c._leaflet_id = null;
    }
    const map = L.map(container.current, defaultMapConfig);
    return map;
  };

  const mapFilters = useMemo(() => (
    (mapFiltersConfig(options)[activeMapType] || []).map(filter => {
      switch (filter.type) {
        case 'input':
          return (
            <div
              key={`${filter.type}-${filter.dest}`}
              style={{ marginBottom: 12 }}
            >
              <label>{t(filter.label)}</label>
              <Input
                placeholder={t(filter.placeholder) || t(filter.label)}
                value={filters[filter.dest] || ''}
                onChange={(e) => {
                  if (filter.dest) {
                    setFilters({ ...Object.assign(filters, { [filter.dest]: e.target.value }) })
                  }
                }}
              />
            </div>
          );
        case 'checkbox':
          return <React.Fragment
            key={`${filter.type}-${filter.dest}`}
          >
            {filter.label ? <label>{t(filter.label)}</label> : null}
            <Checkbox.Group
              value={filters[filter.dest] || (filter.options.filter(o => o.default).map(o => o.value) || [])}
              onChange={ev => setFilters({ ...Object.assign(filters, { [filter.dest]: ev }) })}>
              <Space direction="vertical">
                {filter.options.map(option => (
                  <Checkbox key={option.value} value={option.value}>
                    <div className="checkbox-container">
                      <span>{t(option.label)}</span>
                    </div>
                  </Checkbox>
                ))}
              </Space>
            </Checkbox.Group>
          </React.Fragment>
        case 'radio':
          return <React.Fragment
            key={`${filter.type}-${filter.dest}`}
          >
            {filter.label ? <label>{t(filter.label)}</label> : null}
            <Radio.Group
              style={{ marginBottom: '1rem' }}
              defaultValue={filters[filter.dest] || (filter.options.find(o => o.default) || { value: null }).value}
              onChange={ev => setFilters({ ...Object.assign(filters, { [filter.dest]: ev.target.value }) })}>
              <Space direction="vertical">
                {filter.options.map(option => (
                  <Radio key={option.value} value={option.value}>
                    {t(option.label)}
                  </Radio>
                ))}
              </Space>
            </Radio.Group>
          </React.Fragment>
        case 'select':
          return <React.Fragment
            key={`${filter.type}-${filter.dest}`}
          >
            {filter.label ? <label>{typeof filter.label === 'object' ? filter.label[i18n.language] : t(filter.label)}</label> : null}
            <Select
              allowClear
              showSearch
              filterOption={filterSelectOptions}
              optionFilterProp="children"
              // placeholder={filter.placeholder || filter.label || null}
              value={filters[filter.dest] || (filter.options.find(o => o.default) || { value: null }).value}
              className="map-focus-filter"
              onChange={ev => {
                if (filter.dest === 'riskTypes') {
                  delete filters.riskSubTypes;
                }
                setFilters({ ...Object.assign(filters, { [filter.dest]: ev }) })
              }}>
              {filter.options.filter(option => {
                if (!option.filter) {
                  return true;
                }
                return Object.keys(option.filter).every(key => filters[key] === option.filter[key]);
              }).map(option => (
                <Select.Option
                  key={option.value}
                  value={option.value}>
                  {typeof option.label === 'object' ? option.label[i18n.language] : option.label}
                </Select.Option>
              ))}
            </Select>
          </React.Fragment>
        default:
          return 'undefined type';
      }
    })
  ), [filters, options, activeMapType]);

  useEffect(() => {
    if (initialMarkerSetIsDone) {
      setInitialMarkerSetIsDone(undefined);
    }
  }, []);

  useEffect(() => {
    if (!mapRef) {
      const instance = createInstance();
      setMapRef(instance);
    }
  }, []);

  useEffect(() => {
    if (mapRef) {
      if (polygonLayer) {
        mapRef.removeLayer(polygonLayer)
      }

      if (Array.isArray(polygon)) {
        const layer = L.polygon(polygon, { color: '#00809E' })
          .addTo(mapRef);
        setPolygonLayer(layer);
      }
    }
  }, [polygon, mapRef]);

  useEffect(() => {
    if (allData) {
      if (allData.length === 0) {
        setEmptyStateIsVisible(true);
      } else if (emptyStateIsVisible) {
        setEmptyStateIsVisible(false);
      }
      setData(filterValidGPS(allData));
    } else {
      if (data) {
        setData(null);
      }
    }
  }, [allData]);

  useEffect(() => {
    if (allData) {
      if (activeMapType === 'location') {
        const arr = (filters.type && Array.isArray(filters.type)) ? filters.type : ['mineSite', 'village', 'other']
        setData(filterValidGPS(allData.filter((d) =>
          d.category &&
          d.name &&
          arr.includes(d.category) &&
          (!filters.locationName || filterString(d.name, filters.locationName)),
        )));
      } else if (activeMapType === 'event') {
        clearMapMarkers();
        setData(filterValidGPS(_.cloneDeep(allData || []).map(marker => {
          if (Array.isArray(marker.data)) {
            marker.data = marker.data.map(d => {
              if (filters.period && filters.period !== 'all') {
                const ranges = getDateRanges(filters.period);
                d.inRange = ranges.includes(dateFormat(filters.period, moment(d.date)));
              } else {
                d.inRange = true
              }
              return d;
            }).filter(d =>
              d.inRange
              && (!filters.riskSubTypes || filters.riskSubTypes === d.incindentType)
              && (!filters.riskTypes || filters.riskTypes === d.eventCategory));
          }
          marker.total = marker.data.length;
          return marker;
        }).filter(marker => marker.total)));
        addAllDataToMap();
      }
    }
  }, [filters, activeMapType]);

  useEffect(() => {
    setFiltersOpen(false);
    setFilters(defaultFilters);
    clearMapMarkers();
    if (activeMapType) {
      if (initialMarkerSetIsDone || module === 'pme') {
        onFiltersChange({
          widget: 'map',
          filters: {
            subject: activeMapType,
          },
        });
        if (!initLoaded) {
          setInitLoaded(true);
        }
      } else {
        setInitialMarkerSetIsDone(false);
      }
    }
  }, [activeMapType, language]);

  useEffect(() => {
    if (!initialMarkerSetIsDone) {
      if (activeMapType === initialType) {
        if (initLoaded) {
          onFiltersChange({
            widget: 'map',
            filters: {
              subject: activeMapType,
            },
          });
        }
      } else {
        setActiveMapType(initialType);
      }
    }
  }, [initialMarkerSetIsDone, initialType]);

  useEffect(() => {
    if (!activeMapType) {
      setActiveMapType(initialType);
    }
  }, [activeMapType]);

  useEffect(() => {
    if (mapRef) {
      L.control.scale().addTo(mapRef);
      L.tileLayer(TILE_LAYER_URL, { access_token: MAP_TOKEN }).addTo(mapRef);
    }
  }, [mapRef]);

  useEffect(() => {
    if (mapRef) {
      if (allData && allData.length && !initialRecenterDone) {
        const pos = allData.map(m => [Number(m.marker.lat), Number(m.marker.lng)]);
        const bounds = new L.LatLngBounds(pos);
        mapRef.fitBounds(bounds, { padding: [20, 20] });
        setInitialRecenterDone(true);
      }
    }
  }, [allData, mapRef]);

  useEffect(() => {
    if (mapRef) {
      if (user && !(allData || []).length) {
        const coordinates = findCoordinatesByCountry(user.country) || [0, 0];
        mapRef.setView([coordinates[1], coordinates[0]], SET_VIEW_DEFAULT_ZOOM);
        setMapCenter([coordinates[1], coordinates[0]]);
      }
    }
  }, [user, mapRef]);

  useEffect(() => {
    setInitialRecenterDone(false);
  }, []);

  useEffect(() => {
    if (mapRef && data) {
      if (!initialMarkerSetIsDone) {
        setInitialMarkerSetIsDone(true);
      } else {
        clearMapMarkers();
      }
      addAllDataToMap();
    }
  }, [data, mapRef, activeMapType]);

  useEffect(() => {
    const marker = mapMarkers.find((m) => m.id === activeMarker);
    if (getZoom && marker && mapRef) {
      mapRef.setView([marker.coordinates[0], marker.coordinates[1]], getZoom(mapRef));
    }
  }, [activeMarker]);

  useEffect(() => {
    if (Object.keys(filters).length > 0) {
      setFilters(defaultFilters);
      setFiltersOpen(false);
    }
  }, []);

  return {
    filtersOpen,
    setFiltersOpen,
    mapFilters,
    container,
    activeMarker,
    mapOptionsButtonsConfig,
    emptyStateIsVisible,
    setEmptyStateIsVisible,
  }
}
